import { render, staticRenderFns } from "./EmptyListProduct.vue?vue&type=template&id=64fabc92"
import script from "./EmptyListProduct.vue?vue&type=script&lang=js"
export * from "./EmptyListProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports